<nav class="navbar navbar-expand-lg py-0 my-0">
  <ng-container>
    <div class="navbar-brand mx-5">
      @if (branding$ | async; as branding) {
        <a
          class="header-image"
          [attr.target]="branding.logoLink === '#' ? null : '_blank'"
          [href]="branding.logoLink"
        >
          @if (branding.logoUrl) {
            <img
              class="header-image-img"
              alt="Legal and General"
              [src]="branding.logoUrl"
            />
          } @else {
            <div class="header-image-img-placeholder d-flex align-items-center justify-content-center">
              <div
                class="spinner-border text-colour-blue-600"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          }
        </a>
      } @else {
        <div class="header-image-img-placeholder d-flex align-items-center justify-content-center">
          <div
            class="spinner-border text-colour-blue-600"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      }
    </div>

    <button
      class="navbar-toggler"
      type="button"
      aria-controls="navbarSupportedContent"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="navbarOpen"
      (click)="toggleNavbar()"
    >
      <span class="fa fa-navicon"></span>
    </button>
  </ng-container>

  @if (showNav()) {
    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
      [class.show]="navbarOpen"
    >
      <ng-content />
      <lib-login-menu (showFeedback)="showFeedbackModal()" />
    </div>
  }
</nav>
